import { NgFor, NgIf } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { L10nTranslationModule, L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { AccordionModule } from 'primeng/accordion';

@Component({
	selector: 'supplierDB-registration-overview-selection-tab',
	standalone: true,
	imports: [AccordionModule, NgFor, NgIf, L10nTranslationModule],
	templateUrl: './selection-tab.component.html',
	styleUrl: './selection-tab.component.scss',
})
export class SelectionTabComponent {
	@Input() title: string = '';
	@Input() selectionData: string[] | null = null;

	constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}
}
